import React, { useEffect, useState } from 'react';
import moment from 'moment';

const Bip = (props) => {
    const { bip } = props;
    const [, setForceRender] = useState(0);

    const forceUpdate = () => {
        setForceRender((prev) => prev + 1);
    };

    useEffect(() => {
        // Ajouter un listener pour réagir aux mises à jour
        const update = () => {
            setForceRender((prev) => prev + 1); // Déclencher un re-render
        };
        bip.addListener(update);

        return () => {
            // Nettoyer les listeners lorsqu'on démonte le composant
            bip.listeners = bip.listeners.filter((listener) => listener !== update);
        };
    }, [bip]);

    return (
        <div className='box_bip' id='bip'>
            <div
                className={`${!bip.screenOn ? 'ecran_bip' : bip.alarmOn ? 'ecran_bip_alerte' : bip.messageOn ? 'ecran_bip_message' : 'ecran_bip_allume'}`}
                id='ecran'
            >
                <div>
                    {bip.on ? bip.name : ''}
                </div>
                <h6 className='heure_message_bip' id='heure_message'>
                    {bip.message.date ? moment(bip.message.date).format('Do MMMM YYYY HH:mm:ss') : ''}
                </h6>
                <div className='message_bip' id='message'>
                    {bip.message.text}
                </div>
            </div>
            <div className='menu_bip'>
                <button
                    className='btn_bip_p m-5'
                    onClick={() => {
                        bip.pressButton();
                        forceUpdate();
                    }}
                ></button>
            </div>
        </div>
    );
};

export default Bip;
